import React from "react";
import cn from "classnames";

interface IProps {
  title: string;
  className?: string;
}

const DotLabel = ({ title, className }: IProps) => {
  return <div className={cn(["wbuc-dot-label-title"], className)}>{title}</div>;
};

export default DotLabel;
